import { forwardRef } from 'react';
import { InputText, type InputTextProps } from './InputText';

export type InputPasswordProps = Omit<InputTextProps, 'type'>;

export const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
  (props, ref) => <InputText {...props} ref={ref} type="password" />
);

InputPassword.displayName = 'InputPassword';

export default InputPassword;
